'use client';
import ImageGallery from "@/components/common/image-gallery";
import { PostContentFallback, useLoadPostBySlug } from "@/components/common/posts/posts.provider";
import { SimilarPosts } from "@/components/common/posts/similar-posts";
import SectionPage from "@/components/common/section-page";

export default function PostPage() {
    const { currentPost, postsBasePath } = useLoadPostBySlug("jacqueville-monntee-eaux");

    return (
        <PostContentFallback>
            <article>
                {currentPost && (
                    <div style={{ backgroundImage: `url(${currentPost.image})` }} className={"h-[400px] w-full bg-cover bg-center relative"}>
                        <div className={"bg-bleu-marine h-[100px] w-full flex items-center justify-start absolute bottom-0"}>
                            <SectionPage sectionType={"2xl"}>
                                <h1 className={"text-white text-4xl font-exo"}>{currentPost?.title}</h1>
                            </SectionPage>
                        </div>
                    </div>
                )}

                <SectionPage sectionType={"xl"} className={"my-12"}>
                    <div className="markdown-content text-gray-800">
                        <h1 className="text-3xl font-bold font-exo text-rose mt-8 mb-4">MONTEE DES EAUX, Madame le Directeur Général de Côte d'Ivoire Tourisme apporte son réconfort aux opérateurs hôteliers touchés par les dégâts matériels.</h1>

                        <p className="my-4 text-normal leading-relaxed">
                            Ce Mercredi 23 Août, le Directeur de l'Office a rendu visite aux responsables d'établissements hôteliers récemment victimes des eaux montantes. Madame Malekah MOURAD CONDE les a exhortés à se relever de cette épreuve afin de mieux préparer l'avenir dans le cadre de la promotion de la Destination Côte d'Ivoire.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            A cet effet, Madame le Directeur Général de Côte d'Ivoire Tourisme a présenté les grands axes de sa stratégie pour faire de Jacqueville une destination touristique.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Elle a noté que le développement du tourisme à Jacqueville ne pourra être effectif sans une action concertée des différents acteurs. Elle a invité l'ensemble de l'écosystème du tourisme à s'associer à Côte d'Ivoire Tourisme dans son dessein de transformation de cette ville en station balnéaire de qualité.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Madame CONDE a également eu une séance de travail avec le Sous – Préfet de Jacqueville.
                        </p>
                    </div>


                    <div className={'mt-8'}>
                        <ImageGallery images={
                            Array.from({ length: 9 }).map((_, index) => ({
                                src: `/images${postsBasePath}/${String(currentPost?.slug)}/gallerie/${index + 1}.png`,
                                alt: `image${index + 1}`,
                                width: 700,
                                height: 700,
                            }))
                        } aspectRatio={"video"} />
                    </div>

                    {currentPost && <SimilarPosts currentSlug={currentPost.slug} />}
                </SectionPage>
            </article>
        </PostContentFallback>
    );
}
